import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  OnDestroy,
} from "@angular/core";
import moment from "moment";
import { UI } from "../../../../services/ui.service";
import { SecEventsService } from "../sec-events.service";
import { SecEventType } from "../../../../domain/sec-events";
import { SecEventCategory } from "../../../../domain/sec-event-category";
import { TimeType } from "../../../../domain/time-type";
import { Subscription } from "rxjs";

@Component({
  selector: "evrideo-calendar-expandable-editable-time",
  templateUrl: "./calendar-expandable-editable-time.component.html",
  styleUrls: ["./calendar-expandable-editable-time.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarExpandableEditableTimeComponent
  implements OnInit, OnDestroy
{
  @Input() time;

  @Input() editLocked = true;

  @Input() timeType: TimeType | string;

  @Input() showId;

  @Input() eventData;

  hoursValue: string;
  minutesValue: string;
  secondsValue: string;
  fpsValue: string;
  msValue: string;

  editActive = false;

  fpsSet;

  onTimeChangeSubscription: Subscription;

  constructor(
    private ui: UI,
    private secEventsApi: SecEventsService,
  ) {}

  ngOnInit(): void {
    this.fpsSet = this.time.length === 11;
  }

  ngOnDestroy() {
    this.onTimeChangeSubscription?.unsubscribe();
  }

  startTimeEdit() {
    this.editActive = !this.editActive;
    this.hoursValue = this.time.substring(0, 2);
    this.minutesValue = this.time.substring(3, 5);
    this.secondsValue = this.time.substring(6, 8);
    if (this.fpsSet) {
      this.fpsValue = this.time.substring(9, 11);
    } else {
      this.msValue = this.time.substring(9, 12);
    }
  }

  getEventCategory() {
    if (this.eventData.type === SecEventType.Graphics) {
      return SecEventCategory.Graphics;
    }

    if (this.eventData.type === SecEventType.FloatingMedia) {
      return SecEventCategory.FloatingMedia;
    }

    return SecEventCategory.Signal;
  }

  getEventIdentifier() {
    if (this.eventData.type === SecEventType.Graphics) {
      return this.eventData.properties.name;
    }

    return this.eventData.properties.id;
  }

  async finishTimeEdit(hours, minutes, seconds, lastValue) {
    this.editActive = !this.editActive;

    let newTime = `${hours}:${minutes}:${seconds}.${lastValue}`;

    if (this.timeType === "StartTime" || this.timeType === "EndTime") {
      newTime = `${
        this.eventData.properties.startTime.split("T")[0]
      } ${newTime}`;
    }

    try {
      await this.secEventsApi.updateTime(
        this.getEventCategory(),
        this.showId,
        this.getEventIdentifier(),
        this.eventData.properties.offset,
        this.timeType,
        newTime,
      );
    } catch (error) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "error editing time",
        message: error.message,
      });
    }
  }

  prependZero(event) {
    event.target.value = event.target.value.padStart(2, "0");
  }

  prependZerosMilliseconds(event) {
    event.target.value = event.target.value.padStart(3, "0");
  }
}
